import styled from 'styled-components';
import { media } from '@prima-afp/prima-ui-elements/dist/utils/media/styledConfig';

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ marginBottom }) => marginBottom};
`

export const LogoStyled = styled.img`
  height:30px;
  ${media.sm`
    height: 20px;
  `}
  ${media.xs`
    height: 20px;
  `}
`
export const SloganStyled = styled.img`
  height:30px;
  ${media.sm`
    height: 20px;
  `}
  ${media.xs`
    height: 20px;
  `}
`